import React from "react";

import classnames from "classnames";

import { useUserData } from "hooks";

import styles from "./RiskBanner.module.scss";

export const RiskBanner = () => {
  const { data } = useUserData();

  return (
    <div
      className={classnames(styles.riskBanner, {
        [styles.riskBannerUk]: data?.UKFinProm,
        [styles.riskBannerNonUk]: !data?.UKFinProm,
      })}
    >
      <span>
        Don&apos;t invest unless you&apos;re prepared to lose all the money you invest. This is a high-risk investment
        and you should not expect to be protected if something goes wrong.{" "}
        <a href='https://bnktothefuture.com/uk-risk-disclaimer' target='_blank' rel='noreferrer'>
          Take 2 mins to learn more.
        </a>
      </span>
    </div>
  );
};
